import { render, staticRenderFns } from "./join-dialog.vue?vue&type=template&id=38d64395&"
import script from "./join-dialog.vue?vue&type=script&lang=js&"
export * from "./join-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports